export default function RoadmapComponent(props) {
    return (


            <div>
                <h1>{props.time}</h1>
                {props.text.map(t => <div key={t}>{t}</div>)}
            </div>



    )
}